// ** Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Text from "components/typography/Text";
import Block from "components/layout/Block";
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";
import NoContentWrapper from "components/layout/NoContentWrapper/NoContentWrapper";

// #####################################################

const NotAllowedComponent = () => {
	const { t } = useTranslation(["userProfile"]);

	const userFrozen = useSelector((state) => state.userProfileMain.frozen);
	const userBlockByMe = useSelector(
		(state) => state.userProfileMain.status.blockByMe
	);
	const userBlockMe = useSelector(
		(state) => state.userProfileMain.status.blockMe
	);

	// #####################################################

	return (
		<Block flex column fullHeight>
			<CardWrapper>
				<CardBody>
					<NoContentWrapper>
						<Text>
							{userFrozen
								? t("userProfile:frozen")
								: userBlockByMe && t("userProfile:blockByMe")}
							{userBlockMe && t("userProfile:blockMe")}
						</Text>
					</NoContentWrapper>
				</CardBody>
			</CardWrapper>
		</Block>
	);
};

// #####################################################

export default NotAllowedComponent;

// #####################################################
